
import QuietFooter from "../components/homepage/QuietFooter";

export default function MainLayout({ children }) {
  return (
    <>
      <main>{children}</main>
      <QuietFooter />
    </>
  );
}
